import React from 'react';

import { Spacer, Icon as OrcIcon } from '@ontruck/orc';

const logTypeIconMap = {
  INCIDENT: 'girded-exclamation',
  TASK: 'girded-exclamation',
  INFO: 'girded-info',
};

const logTypeIconColorMap = {
  INCIDENT: 'error500',
  TASK: 'error500',
  INFO: 'primary300',
};

const Icon = ({ log_type, ...props }) => {
  const iconGlyph = logTypeIconMap[log_type] || logTypeIconMap.INFO;

  const iconColor = logTypeIconColorMap[log_type] || logTypeIconColorMap.INFO;

  return (
    <Spacer {...props} data-testid="log-icon">
      <OrcIcon glyph={iconGlyph} color={iconColor} size="1.6rem" />
    </Spacer>
  );
};

export default Icon;
